<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Select from '$components/Form/Select.svelte';
    import Textarea from '$components/Form/Textarea.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const furnitureTypeOptions = [
        `Meubles de salon`,
        `Salle à manger`,
        `Chambre à coucher`,
        `Bureau`,
        `Jardin`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const customOrPrefabricatedOptions = [`Sur mesure`, `Préfabriqués`, `Les deux`].map(
        (v) => ({ label: v, value: v, key: v }),
    );

    const decorationStyleOptions = [
        `Contemporain`,
        `Vintage`,
        `Ethnique`,
        `Classique`,
        `Moderne`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const additionalServicesOptions = [
        `Livraison`,
        `Montage`,
        `Conseil en décoration`,
        `Aucun`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.ameublement.furnitureType}
        class=""
        let:field
        let:id
        label={`Quel type de mobilier recherchez-vous principalement ?`}
        required={false}
        helpLabel="3 sélections possibles"
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            max={3}
            defaultClass="grid grid-cols-1 @[450px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={furnitureTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.ameublement.customOrPrefabricated}
        class=""
        let:field
        let:id
        label={`Êtes-vous intéressé par des meubles sur mesure ou préférez-vous des modèles préfabriqués ?`}
        required={false}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[450px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={customOrPrefabricatedOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.ameublement.decorationStyle}
        class=""
        let:field
        let:id
        label={`Quel est votre style de décoration préféré ?`}
        required={false}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={decorationStyleOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.ameublement.additionalServices}
        class=""
        let:field
        let:id
        label={`Avez-vous besoin de services supplémentaires tels que la livraison, le montage ou le conseil en décoration ?`}
        required={false}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[450px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={additionalServicesOptions}
        />
    </Row>

    <Row {form} field={fields.message} label={'Votre demande'} required let:field>
        <p>Précisez votre besoin, soyez le plus précis dans votre demande</p>

        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin, soyez le plus précis dans votre demande`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
